/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import cx from 'classnames';
import Icon from 'components/core/icon';

import s from './styles.module.scss';

interface CheckboxProps {
  className?: string;
  id?: string | null;
  name: string;
  label: string;
  dark?: boolean;
  onClick?: React.MouseEventHandler<HTMLInputElement> | null;
  checked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement> | null;
}

const Checkbox = ({
  className,
  id = null,
  name,
  label,
  dark = false,
  onClick = null,
  checked = false,
  onChange,
  ...props
}: CheckboxProps) => (
  <label {...props} className={cx(s.checkboxWrapper, className)} htmlFor={id || name}>
    <input
      checked={checked}
      onChange={onChange ?? (onClick as unknown as React.ChangeEventHandler<HTMLInputElement>) ?? undefined}
      name={name}
      type="checkbox"
      id={id || name}
      className={cx(s.checkbox, s.checkboxInput)}
    />
    <div className={cx(s.checkboxFakebox, s.checkbox, dark && s.dark, checked && s.checkboxChecked)}>
      <Icon
        icon={Icon.icons.check}
        width="12"
        height="12"
        className={cx(s.checkboxIcon, checked && s.checkboxIconChecked)}
      />
    </div>
    <div className={s.checkboxLabelText}>{label}</div>
  </label>
);

export default Checkbox;
